export default function StatsGroup({stats}: {stats: any}) {

    return stats.map((stat: any,x: Number) => (
        <div key={stat.title+x} className="border-t-2 border-gray-100 pt-6">
            <dt className="text-base font-medium text-gray-500">{stat.title}</dt>
            <dd className="text-3xl font-bold tracking-tight text-gray-900">{stat.text}</dd>
        </div>
    ))
}